<style>
  .plainBackGround[_ngcontent-c4] {
    border: 2px solid #bbbac1;
    margin-bottom: 5px;
    padding: 5px;
  }

  .card > .card-body {
    padding: 5px 22px;
    height: 100%;
  }

  button.btn:focus {
    background-color: rgb(26, 235, 60);
    border-radius: 5px;
    border-color: rgb(0, 0, 0);
  }
  button.add {
    all: unset;
  }
  .glyphicon.glyphicon-minus-sign:hover {
    background-color: #b81616;
    transition: 0.7s;
  }
  .glyphicon.glyphicon-edit:hover {
    background-color: rgb(94, 87, 87);
    transition: 0.7s;
  }

  /* .table > tbody > tr > td {
    padding: 1.5% 2%;
    line-height: 17px;
    border-top: 1px solid gainsboro;
    padding-bottom: 1%;
  } */

  .container {
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  label {
    width: 109px;
  }
  .glyphicon-holder-right {
    float: right;
  }
</style>

<ba-card>
  <form [formGroup]="productForm">
    <div class="row" style="margin-top: -15px">
      <!-- <div class="col-md-12 plainBackGround" [style.minHeight]="discountLeftMinHeight()"> -->
      <div class="col-md-12 plainBackGround">
        <div class="row" *ngIf="masterService.DispatchName!='Quotation'">
          <div class="col-sm-3half">
            <label style="width: 100%">Job No :</label>
          </div>
          <div class="col-md-3">
            <!-- <input ngui-auto-complete class="form-control" [source]="JobnoItem.bind(this)" max-num-list="10"
                            list-formatter="jC_Code" display-property-name="jC_Code" style="margin-bottom:5px"
                            placeholder="JC01-MMX-2019" [(ngModel)]="selectedJobNo" (ngModelChange)="JobChanged($event)"
                            [ngModelOptions]="{standalone: true}" (keyup.enter)="EnterJob($event)"
                            (click)="checkValidity()" (keyup.enter)="checkValidity()"> -->

            <input
              tabindex="0"
              class="form-control"
              style="margin-bottom: 5px"
              placeholder="Press Enter To select Job"
              [(ngModel)]="selectedJobNo"
              [ngModelOptions]="{standalone: true}"
              (dblclick)="EnterJobNo()"
              (keyup.enter)="EnterJobNo()"
              readonly
            />
            <!-- 
                        <select tabindex="-1" style="width:100%;" formControlName="JobID" (ngModelChange)="JobChanged($event)">
                                <option *ngFor="let u of JobList" [ngValue]="u">{{u._id}}</option>
                            </select> -->
          </div>
          <div class="col-sm-3half">
            <label
              *ngIf="masterService.DispatchName != 'DispatchOut'"
              style="width: 100%"
              >Remarks :</label
            >
          </div>
          <div class="col-md-6">
            <input
              *ngIf="masterService.DispatchName != 'DispatchOut'"
              tabindex="-1"
              type="text"
              style="width: 100%"
              [(ngModel)]="remarks"
              [ngModelOptions]="{standalone: true}"
              (keyup)="RemarksType()"
            />
          </div>
        </div>
        <div
          *ngIf="masterService.DispatchName!='Quotation'"
          style="
            border: 1px solid;
            border-color: #c1bebe;
            margin-top: 0px;
            margin-bottom: 3px;
            margin-right: -30px;
            width: 95%;
          "
        ></div>
        <!-- *ngIf="itemcheck!=false"  -->
        <div class="row">
          <div class="col-sm-3half">
            <label style="width: 100%">Item Code :</label>
          </div>
          <div class="col-md-2">
            <!-- <input tabindex="-1" type="text" style="width:100%" formControlName="MENUCODE" (keydown.enter)="menucodeChanged($event.target.value)"> -->
            <!-- <input tabindex="2" ngui-auto-complete [source]="codedropListItem.bind(this)" max-num-list="25"
                            list-formatter="MENUCODE" formControlName="MENUCODE" style="width:100%;text-align: right;"
                            (ngModelChange)="itemChanged($event)" display-property-name="MENUCODE"> -->

            <input
              tabindex="1"
              id="MENUCODE"
              formControlName="MENUCODE"
              style="width: 100%"
              placeholder="Enter to select product"
              (keydown.enter)="getProductFromMenuCode($event)"
            />
            <!-- (keydown.enter)="getProductFromMenuCode($event);" -->
          </div>
          <div class="col-sm-3half" *ngIf="AppSettings.BarcodeInBilling!=0">
            <label>Item Name :</label>
          </div>
          <div class="col-sm-7">
            <!-- <p-autoComplete tabindex="2" #onAddFocus formControlName="selectedProd" [suggestions]="results | async" (completeMethod)="search($event)" field="DESCA" [dropdown]="true"  (onDropdownClick)="handleDropdownClick($event)" (ngModelChange)="itemChanged($event)" (onFocus)="onIFocus($event)" [(ngModel)]="MenuItem"></p-autoComplete> -->
            <!-- <input tabindex="2" ngui-auto-complete [source]="dropListItem.bind(this)" max-num-list="25"
                            list-formatter="DESCA" formControlName="selectedProd" style="width:100%"
                            (ngModelChange)="itemChanged($event)" display-property-name="DESCA"> -->

            <input
              tabindex="2"
              formControlName="selectedProd"
              style="width: 100%"
              placeholder="press Enter to select Product"
              (keydown.enter)="EnterMENUCODE($event);"
              (dblclick)="EnterMENUCODE($event);"
            />
          </div>
          <!-- 
                    <div class="col-sm-7" *ngIf="masterService.DispatchName=='DispatchIn'">
                       
                        <input tabindex="2" ngui-auto-complete [source]="DLdropListItem.bind(this)" max-num-list="25" list-formatter="DESCA" formControlName="selectedProd"
                            style="width:100%" (ngModelChange)="itemChanged($event)" display-property-name="DESCA">
                    </div> -->

          <!-- <div class="col-sm-3half" *ngIf="AppSettings.BarcodeInBilling!=0">
                    <label>Item Name :</label>
                </div>
                <div class="col-sm-7" *ngIf="AppSettings.BarcodeInBilling!=0">
                    <p-autoComplete tabindex="2" #onAddFocus formControlName="selectedProd" [suggestions]="results | async" (completeMethod)="search($event)" field="DESCA" [dropdown]="true"  (onDropdownClick)="handleDropdownClick($event)" (ngModelChange)="itemChanged($event)" (onFocus)="onIFocus($event)"></p-autoComplete>
                    <input tabindex="2" ngui-auto-complete [source]="dropListItem.bind(this)" max-num-list="25" list-formatter="DESCA" formControlName="selectedProd"
                        style="width:100%" (ngModelChange)="itemChanged($event)" name="DescA" display-property-name="DESCA">-->
          <!-- </div>  -->
        </div>
        <div class="row" disabled="itemcheck==false">
          <!-- <div class="col-sm-3half">
                    <label style="width:100%;">Units :</label>
                </div>
                <div class="col-md-2">
                    <select tabindex="-1" style="width:100%;" formControlName="SelectedAltUnit" (ngModelChange)="AltUnitChange($event)">
                                    <option *ngFor="let u of selectedItem.AlternateUnits" [ngValue]="u">{{u.ALTUNIT}}</option>
                                </select>
                </div> -->
          <div class="col-sm-3half">
            <label>Rate :</label>
          </div>
          <div class="col-md-2">
            <input
              tabindex="-1"
              type="number"
              #rateBox
              style="width: 100%; text-align: right"
              formControlName="RATE"
              (change)="txtRateChange($event.target.value)"
            />
          </div>
          <div class="col-sm-3half">
            <label>Quantity :</label>
          </div>
          <div class="col-md-2">
            <input
              tabindex="3"
              type="number"
              id="quantityBox"
              #quantityBox
              style="width: 100%; text-align: right"
              formControlName="Quantity"
              (keyup)="txtQuantityChange($event.target.value)"
              (keydown.enter)="Catchtab()"
              (keydown.tab)="Catchtab()"
              (dblclick)="Catchtab()"
              [disabled]="selectedJobNo == null && selectedJobNo == ''"
            />
          </div>
          <div class="col-sm-3half">
            <label>Vehicle no.:</label>
          </div>
          <div class="col-md-3">
            <input
              tabindex="-1"
              type="text"
              style="width: 100%"
              formControlName="VEHNO"
              readonly="readonly"
              disabled
            />
          </div>
        </div>
        <div [hidden]="voucherType==9" class="row" disabled="itemcheck==false">
          <div class="col-sm-3half">
            <label>Amount :</label>
          </div>
          <div class="col-md-2">
            <input
              tabindex="-1"
              type="text"
              style="width: 100%; text-align: right"
              formControlName="AMOUNT"
              readonly="readonly"
              disabled
            />
          </div>

          <div class="col-sm-3half">
            <label>Engine No :</label>
          </div>
          <div class="col-md-2">
            <input
              tabindex="-1"
              type="text"
              style="width: 100%"
              formControlName="ENGINE"
              readonly="readonly"
              disabled
            />
          </div>

          <div class="col-sm-3half">
            <label>Customer Name:</label>
          </div>
          <div class="col-md-3">
            <input
              tabindex="-1"
              type="text"
              style="width: 100%"
              formControlName="CUSNAME"
              readonly="readonly"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3half">
            <label>Model :</label>
          </div>
          <div class="col-md-2">
            <input
              tabindex="-1"
              type="text"
              style="width: 100%"
              formControlName="MODEL"
              readonly="readonly"
              disabled
            />
          </div>

          <!-- for selecting non-warranty in deliver out -->

          <div
            *ngIf="warrantyURL === '/pages/inventory/dispatch'"
            class="col-sm-3half"
            style="width: 150px"
          >
            <label>Warranty :</label>
            <input
              id="warranty"
              type="radio"
              name="warranty"
              (keydown.tab)="onFocusAdd()"
              [(ngModel)]="warranty"
              [ngModelOptions]="{standalone: true}"
              value="1"
            />
          </div>
          <div
            *ngIf="warrantyURL === '/pages/inventory/dispatch'"
            class="col-sm-3half"
            style="width: 150px"
          >
            <label>Non-Warranty :</label>
            <input
              type="radio"
              name="warranty"
              (keydown.tab)="onFocusAdd()"
              [(ngModel)]="warranty"
              [ngModelOptions]="{standalone: true}"
              value="0"
            />
          </div>

          <!-- for patching values of non-warranty and warranty in delivery in -->

          <div
            *ngIf="warrantyURL === '/pages/inventory/dispatchIn'"
            class="col-sm-3half"
            style="width: 150px"
          >
            <label>Warranty :</label>
            <input
              type="radio"
              id="warranty"
              [(ngModel)]="warranty"
              [ngModelOptions]="{standalone: true}"
              [value]="1"
              disabled
            />
          </div>
          <div
            *ngIf="warrantyURL === '/pages/inventory/dispatchIn'"
            class="col-sm-3half"
            style="width: 150px"
          >
            <label>Non-Warranty :</label>
            <input
              type="radio"
              name="warranty"
              [(ngModel)]="warranty"
              [ngModelOptions]="{standalone: true}"
              [value]="0"
              disabled
            />
          </div>
          <div class="col-sm-3">
            <button
              tabindex="9"
              id="add"
              class="btn btn-success"
              (click)="onAddClick()"
              [disabled]="TrnProdObj == null || TrnProdObj.MCODE==null||TrnProdObj.Quantity==null || TrnProdObj.Quantity == 0"
            >
              Add
            </button>
          </div>

          <!-- <div class="col-sm-3half" *ngIf="!showDiscount && AppSettings.HasItemTypeInItem != 0 && TrnProdObj.HASITEMTYPE != 0">
                    <label>Item Type:</label>
                </div>
                <div class="col-md-3" style="padding-right:0px; margin-right:15px;" *ngIf="!showDiscount && AppSettings.HasItemTypeInItem != 0 && TrnProdObj.HASITEMTYPE != 0">
                    <select tabindex="4" style="width: 100%" formControlName="ITEMTYPE">
                        <option *ngFor="let i of itemTypeList" [value]="i.ITEMTYPE">{{i.ITEMTYPE}}</option>
                    </select>
                </div> -->
          <!-- <div class="col-md-4" *ngIf="!showDiscount">
                    <button tabindex="5" class="btn btn-success btn-add-focus" (click)="onAddClick()" [disabled]="TrnProdObj == null || TrnProdObj.MCODE==null||TrnProdObj.Quantity==null || TrnProdObj.Quantity <= 0">Add</button>
                </div> -->
          <div [hidden]="true">
            <div class="col-sm-3half">
              <label>Discount :</label>
            </div>
            <div class="col-md-2">
              <input
                tabindex="-1"
                type="number"
                style="width: 100%"
                #discountBox
                formControlName="IndDiscountValue"
                (change)="IndDiscountChange()"
              />
            </div>
            <div class="col-md-4">
              <label style="width: 30px"
                ><input
                  tabindex="-1"
                  type="radio"
                  style="height: 13px"
                  value="%"
                  formControlName="radioIndDiscount"
                  (change)="IndDiscountChange()"
                />%</label
              >
              <label style="width: 40px; margin-right: 30px"
                ><input
                  tabindex="-1"
                  type="radio"
                  style="height: 13px"
                  value="amt"
                  formControlName="radioIndDiscount"
                  (change)="IndDiscountChange()"
                />Amt</label
              >
            </div>
          </div>
        </div>
        <div class="row" [hidden]="true">
          <div
            class="col-sm-3half"
            *ngIf="AppSettings.HasExpiryDateInItem != 0"
          >
            <label>Expiry Date:</label>
          </div>
          <div
            class="col-md-2"
            style="padding-right: 0px"
            *ngIf="AppSettings.HasExpiryDateInItem != 0"
          >
            <input
              tabindex="-1"
              type="date"
              style="width: 90%"
              formControlName="EXPDATE"
            />
          </div>
        </div>
        <div class="row" *ngIf="voucherType==24">
          <div class="col-sm-3half">
            <label>Warehouse :</label>
          </div>
          <div class="col-md-2" style="padding-right: 0px">
            <select style="width: 95%" formControlName="WAREHOUSE">
              <option
                *ngFor="let w of masterService.warehouseList$ | async"
                [ngValue]="w.NAME"
              >
                {{w.NAME}}
              </option>
            </select>
          </div>

          <div [hidden]="voucherType==9" class="col-sm-3half">
            <label>Supplier :</label>
          </div>
          <div
            [hidden]="voucherType==9"
            class="col-md-3"
            style="padding-right: 0px"
          >
            <select style="width: 95%" formControlName="TRNAC">
              <option *ngFor="let s of SupplierList" [ngValue]="s.ACID">
                {{s.ACNAME}}
              </option>
            </select>
          </div>
        </div>
        <div class="row" *ngIf="voucherType==9">
          <fieldset
            style="
              width: 97%;
              height: 55px;
              margin-left: 10px;
              margin-bottom: 5px;
            "
          >
            <legend style="width: 180px; margin: 0px">
              <label style="width: 100%; font-size: 13px; height: 30px">
                Stock Status :</label
              >
            </legend>
          </fieldset>
        </div>
        <!-- <div class="row">
                    <div class="col-md-1"> -->
        <!-- <button tabindex="9" class="btn btn-success" (click)="onAddClick()"
                            [disabled]="TrnProdObj == null || TrnProdObj.MCODE==null||TrnProdObj.Quantity==null || TrnProdObj.Quantity == 0">Add</button>

                             -->

        <!-- || jobValue == null -->
        <!-- <button *ngIf="voucherType==24" tabindex="9" class="btn btn-success btn-add-focus" (click)="onAddClick()" [disabled]="TrnProdObj == null || TrnProdObj.MCODE==null||TrnProdObj.Quantity==null || TrnProdObj.Quantity == 0 ">Add</button> -->
        <!-- </div>
                </div> -->
      </div>

      <!-- <div class="col-md-3 plainBackGround" style="border-left:0px;" *ngIf="voucherType!=24 ">
                <div
                    style="font-size:smaller;border: 2px solid #E6E6E6; background:#E6E6E6; border-radius:3px;padding:3px;color: blue;">

                    <div style="margin:0px;height: 25px">
                        <label style="width:100px;height:18px;">
                            Stock Quantity:
                        </label>
                        <label style="width:85px;height:18px">{{selectedItem.MAXSQTY}}</label>

                    </div>
                    <div style="margin:0px;height: 25px">
                        <label style="width:100px;height:18px">
                            Re-Order Level:
                        </label>
                        <label style="width:85px;height:18px">{{selectedItem.ROLEVEL}} </label>

                    </div>
                    <div style="margin:0px;height: 25px">
                        <label style="width:100px;height:18px">
                            MaxOrder Level:
                        </label>
                        <label style="width:85px;height:18px">{{selectedItem.MAXLEVEL}} </label>

                    </div>
                    <div style="margin:0px;height: 25px">
                        <label style="width:100px;height:18px">
                            Selling Rate:
                        </label>
                        <label style="width:85px;height:18px"> </label>

                    </div>
                    <div style="margin:0px;height: 25px">
                        <label style="width:100px;height:18px">
                            Min Order Level:
                        </label>
                        <label style="width:85px;height:18px">{{selectedItem.MINLEVEL}} </label>

                    </div>
                    <div *ngIf="showDiscount">
                        <label style="width:80px;height:18px">Flat Discount:</label>
                        <input type="number" style="width:85px" formControlName="flatDiscountValue"
                            (change)="flatDiscountChange()">
                        <div>
                            <label style="width:30px;margin-left:90px;height:25px;"><input type="radio"
                                    style="height:13px" formControlName="radioFlatDiscount" value="%"
                                    (change)="flatDiscountChange()">%</label>
                            <label style="width:40px;height:25px"><input type="radio" style="height:13px"
                                    formControlName="radioFlatDiscount" value="amt"
                                    (change)="flatDiscountChange()">Amt</label>
                        </div>
                    </div>

                </div>

            </div> -->
      <div
        class="col-md-3 plainBackGround"
        style="height: 200px; overflow: scroll"
        *ngIf="previousOpeningStockData.length>0 && voucherType==24"
      >
        <div *ngFor="let p of previousOpeningStockData">
          <div style="margin: 0px; height: 25px">
            <label style="width: 35%; height: 18px"> Product: </label>
            <label style="width: 60%; height: 18px; font-size: 11px"
              >{{p.ITEMDESC}}</label
            >
          </div>
          <div style="margin: 0px; height: 25px">
            <label style="width: 35%; height: 18px"> Voucher No.: </label>
            <label style="width: 60%; height: 18px">{{p.VCHRNO}}</label>
          </div>
          <div style="margin: 0px; height: 25px">
            <label style="width: 35%; height: 18px"> Quantity: </label>
            <label style="width: 60%; height: 18px" *ngIf="p.REALQTY_IN>0"
              >{{p.REALQTY_IN}}</label
            >
            <label style="width: 60%; height: 18px" *ngIf="p.RealQty>0"
              >-{{p.RealQty}}</label
            >
          </div>
          <div style="margin: 0px; height: 25px">
            <label style="width: 35%; height: 18px"> Supplier: </label>
            <label style="width: 60%; height: 18px">{{p.ACNAME}}</label>
          </div>
          <div style="margin: 0px; height: 25px">
            <label style="width: 35%; height: 18px"> Warehouse: </label>
            <label style="width: 60%; height: 18px">{{p.WAREHOUSE}}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!--<div class="content ">
                    <div class="col col-md-9 left">-->

      <div class="wrapper">
        <div class="container" style="height: 300px">
          <!--<div class="col-md-9 plainBackGround " style="min-height: 300px;height:300px">-->

          <div
            #prodlistTable
            id="prodlistTable"
            style="background-color: #ffffff"
          >
            <table
              class="table table-stripped"
              style="width: 100%; border-collapse: collapse"
            >
              <thead>
                <tr>
                  <th style="width: 3%; color: black; text-align: center">
                    Sno
                  </th>
                  <th style="width: 13%; color: black; text-align: center">
                    ItemCode
                  </th>
                  <th style="width: 20%; color: black; text-align: center">
                    ItemName
                  </th>
                  <th style="width: 5%; color: black; text-align: center">
                    Unit
                  </th>
                  <th style="width: 5%; color: black; text-align: center">
                    Rate
                  </th>
                  <th
                    style="width: 7px; color: black; text-align: center"
                    [hidden]="voucherType==9"
                    *ngIf="AppSettings.ENABLEMULTICURRENCY==1"
                  >
                    NcRate
                  </th>
                  <th style="width: 5%; color: black; text-align: center">
                    Quantity
                  </th>
                  <th
                    style="width: 7%; color: black; text-align: center"
                    [hidden]="voucherType==9"
                  >
                    Gross Amt
                  </th>
                  <th
                    style="width: 5%; color: black; text-align: center"
                    [hidden]="voucherType==9"
                  >
                    VAT
                  </th>
                  <th style="width: 7%; color: black; text-align: center">
                    Total
                  </th>
                  <th style="width: 10%; color: black; text-align: center">
                    Mode
                  </th>
                  <th style="width: 12%"></th>

                  <!-- <th style="width:10px" *ngIf="voucherType==24 || voucherType==9">Warehouse
                                            Warehouse</div>
                                        </th>
                                         <th style="width:10px" *ngIf="voucherType==24">Supplier
                                            Supplier</div>
                                        </th> -->
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <td [hidden]="voucherType==9" colspan="6"></td>
                  <td *ngIf="voucherType==9" colspan="4"></td>
                  <td>
                    <div class="c3">{{TrnMainObj.TOTAMNT|twoDigitNumber}}</div>
                  </td>
                  <!-- <td *ngIf="showDiscount">
                                        <div class="c3">
                                            {{TrnMainObj.TOTALDISCOUNT|twoDigitNumber}}
                                        </div>
                                    </td> -->
                  <td>
                    <div class="c3">{{TrnMainObj.VATAMNT|twoDigitNumber}}</div>
                  </td>
                  <td>
                    <div class="c3">
                      {{TrnMainObj.NETWITHOUTROUNDOFF|twoDigitNumber}}
                    </div>
                  </td>
                </tr>
              </tfoot>
              <tbody>
                <tr
                  style="text-align: center"
                  *ngFor="let tp of TrnMainObj.ProdList;let tpindex=index"
                  (dblclick)="TableRowDoubleClickEvent(tp,tpindex)"
                >
                  <td style="width: 3%; text-align: center">{{tpindex+1}}</td>
                  <td style="width: 13%; text-align: center">
                    {{tp.MENUCODE}}
                  </td>
                  <td style="width: 20%">{{tp.ITEMDESC}}</td>
                  <td style="width: 5%">pc</td>
                  <td style="width: 5%">{{tp.RATE}}</td>
                  <td
                    style="width: 7px"
                    [hidden]="voucherType==9"
                    *ngIf="AppSettings.ENABLEMULTICURRENCY==1"
                  >
                    {{tp.NCRATE}}
                  </td>
                  <td style="width: 5%">{{tp.Quantity}}</td>
                  <td style="width: 7%" [hidden]="voucherType==9">
                    {{tp.AMOUNT|twoDigitNumber}}
                  </td>
                  <td style="width: 5%" [hidden]="voucherType==9">
                    {{tp.VAT|twoDigitNumber}}
                  </td>
                  <td style="width: 7%">{{tp.NETAMOUNT|twoDigitNumber}}</td>
                  <td style="width: 10%; padding-left: 1%">
                    {{tp.WarrantyStr}}
                  </td>
                  <td style="width: 12%">
                    <!-- <div class="row" > -->
                    <!-- <div class="col-md-1"  > -->
                    <span
                      class="glyphicon glyphicon-minus-sign"
                      [disabled]="mode=='view'"
                      (click)="delRowCategory(tpindex)"
                      style="cursor: pointer; color: red"
                    ></span>
                    <span
                      class="glyphicon glyphicon-edit"
                      [disabled]="mode=='view'"
                      (click)="TableRowDoubleClickEvent(tp,tpindex)"
                      style="
                        margin-top: 8%;
                        float: right;
                        margin-right: 36%;
                        cursor: pointer;
                        color: black;
                      "
                    ></span>
                  </td>
                  <!-- <td [hidden]= "voucherType==9" *ngIf="AppSettings.HasItemTypeInItem != 0 && deliverytype==true" style="width:9px" >{{tp.ITEMTYPE}}  -->
                  <!-- <td [hidden]= "voucherType==9" *ngIf="AppSettings.HasItemTypeInItem != 0 && deliverytype==true" style="width:9px" >{{tp.RECEIVEDTYPE}}  -->
                  <!-- <td style="width:10px" *ngIf="voucherType==24 || voucherType==9">{{tp.WAREHOUSE}}</td> -->
                  <!-- <td style="width:10px" *ngIf="voucherType==24">{{tp.TRNAC}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--   </div>
                    </div>
                </div>-->
    </div>

    <div class="row">
      <div class="col-md-12" style="padding-left: 0px; padding-right: 0px">
        <div
          style="
            font-size: smaller;
            border: 2px solid #e6e6e6;
            background: #e6e6e6;
            padding: 7px;
          "
        >
          <!-- <h6 style="margin-left: 5px;">Total Info:</h6> -->
          <!--<div>

                    <label style="width:30px;margin-left:90px;height:25px;"><input type="radio" name="rFlatDiscount" style="height:13px" [(ngModel)]="radioFlatDiscount" value="%" (ngModelChange)="flatDiscountChange()">%</label>
                    <label style="width:40px;height:25px"><input type="radio" name="rFlatDiscount" style="height:13px" [(ngModel)]="radioFlatDiscount" value="amt" (ngModelChange)="flatDiscountChange()">Amt</label>
                    <label style="width:80px;height:18px">Flat Discount:</label>
                    <input type="text" style="width:85px" [(ngModel)]="flatDiscountValue" (ngModelChange)="flatDiscountChange()">
                </div>-->
          <!--<div style="margin:0px; display:inline-block; margin-bottom:5px;">
                    <label style="width:auto;height:18px">
                    Sub Total:
                </label>
                    <input type="text" style="width:85px;" [(ngModel)]="TrnMainObj.TotalWithIndDiscount">

                </div>
                <div style="margin:0px; display:inline-block; margin-left: 5px;">
                    <label style="width:auto;height:18px">
                    Gross Amt.:
                </label>
                    <input type="text" style="width:85px; " [(ngModel)]="TrnMainObj.TOTAMNT">

                </div>-->
          <div style="margin: 0px; display: inline-block; margin-left: 5px">
            <label style="width: auto; height: 18px"> Taxable Amt: </label>
            <input
              type="number"
              style="width: 100px"
              disabled
              value="{{TrnMainObj.TAXABLE|twoDigitNumber}}"
            />
          </div>
          <div style="margin: 0px; display: inline-block; margin-left: 15px">
            <label style="width: auto; height: 18px"> NonTaxable: </label>
            <input
              type="number"
              style="width: 100px"
              disabled
              value="{{TrnMainObj.NONTAXABLE|twoDigitNumber}}"
            />
          </div>
          <!--<div style="margin:0px; display:inline-block; margin-left: 5px;">
                    <label style="width:auto;height:18px">
                    VAT:
                </label>
                    <input type="text" style="width:85px;" [(ngModel)]="TrnMainObj.VATAMNT">

                </div>-->
          <div style="margin: 0px; display: inline-block; margin-left: 15px">
            <label style="width: auto; height: 18px">Rounding Adj:</label>
            <input
              type="number"
              style="width: 100px"
              disabled
              value="{{TrnMainObj.ROUNDOFF|twoDigitNumber}}"
            />
          </div>
          <div style="margin: 0px; display: inline-block; margin-left: 15px">
            <label style="width: 57px; height: 18px"> Net Amt: </label>
            <input
              type="number"
              style="width: 100px"
              disabled
              value="{{TrnMainObj.NETAMNT|twoDigitNumber}}"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</ba-card>
<!--<div [ngBusy]="subscriptions" ></div>-->
<div
  class="modal fade"
  bsModal
  #childModal="bs-modal"
  [config]="{backdrop: 'static'}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" aria-label="Close" (click)="hideChildModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Information1</h4>
      </div>
      <div class="modal-body">{{DialogMessage}}</div>
      <div *ngIf="lengths==true" class="modal-footer">
        <button class="btn btn-primary confirm-btn" (click)="onClickYes()">
          Yes
        </button>
        <button
          class="btn btn-primary confirm-btn"
          type="button"
          (click)="onClickNo()"
        >
          No
        </button>
      </div>
    </div>
  </div>
</div>

<generic-popup-grid
  #genericGridJCList
  [popupsettings]="gridJCListSettings"
  (onItemDoubleClick)="onJCSelect($event)"
></generic-popup-grid>

<generic-popup-grid
  #genericGridProductList
  [popupsettings]="gridMENUCODEsettings"
  (onItemDoubleClick)="onProductSelect($event)"
  [inputVchrType]="inputVchrType"
  [inputVchrno]="selectedJobNo"
></generic-popup-grid>
